import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DynamicForm, FormConfiguration, FormData, SaveFormRequest, SaveFormResponse } from '../interfaces/dynamic-form.interface';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {

  private formsCacheByProgram = new Map<string, FormConfiguration>();

  constructor(private http: HttpClient) { }

  /**
   * Load all available forms for a specific program
   */
  getForms(programCode: string): Observable<DynamicForm[]> {
    const cached = this.formsCacheByProgram.get(programCode);
    if (cached) {
      return of(cached.forms);
    }

    return this.http.get<FormConfiguration>(`/assets/data/programs/${programCode}/provider-enrollment-forms.json`).pipe(
      map(config => {
        this.formsCacheByProgram.set(programCode, config);
        return config.forms;
      })
    );
  }

  /**
   * Get a specific form by ID
   */
  getFormById(programCode: string, formId: number): Observable<DynamicForm | undefined> {
    return this.getForms(programCode).pipe(
      map(forms => forms.find(f => f.id === formId))
    );
  }

  /**
   * Get forms that need to be displayed based on user context
   * This can be enhanced to filter forms based on relationship, live-in status, etc.
   */
  getRequiredForms(programCode: string, context?: any): Observable<DynamicForm[]> {
    return this.getForms(programCode).pipe(
      map(forms => {
        // For now, return all forms
        // Later, filter based on context (e.g., hide CA DE 1378J if not spouse/parent)
        return forms;
      })
    );
  }
}
